<template>
  <el-select v-bind="$attrs" filterable clearable remote :remote-method="remoteMethod" v-model="curSelect" popper-class="el-select-thick-scrollbar">
    <el-option
      v-for="item in optionsList"
      :key="item.id"
      :label="item.name"
      :value="item.id">
    </el-option>
  </el-select>
</template>
<script>
import $ from 'jquery';
import {ajax} from "@/api/jqajax";

export default {
  components: {},
  computed: {},
  model: {
    prop: 'value'
  },
  props: {
    value: {type: [String, Number], default: ''},
    limit: {type: Number, default: 10000000}
  },
  data() {
    return {
      optionsList: [],
      curSelect: this.value
    };
  },
  created() {
    this.load()
  },
  mounted() {
  },

  watch: {
    value(newval) {
      this.curSelect = newval;
    },
    curSelect(newval) {
      this.$emit('input', newval)
    }
  },
  methods: {
    load(keyword = '') {
      ajax('get', {page: 1, per_page: this.limit, keyword}, 'admin/cost-center', (res) => {
        if (res.error_code == '0') {
          this.optionsList = res.data.data;
        }
      })
    },
    remoteMethod(query) {
      this.load(query)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/projectComponents/ChengBenZhongXin.vue